import { useEffect, useState } from 'react';
import { format } from 'date-fns';
import { ReactComponent as YaongCat } from '../../assets/images/popups/v2_popup_yaong.svg';
import PopupSection1 from '../../assets/images/popups/v2_popup_1.png';
import PopupSection2 from '../../assets/images/popups/v2_popup_2.png';
import PopupSection3 from '../../assets/images/popups/v2_popup_3.png';
import PopupSection4 from '../../assets/images/popups/v2_popup_4.png';


export const V2_RENEWAL_DISMISS_KEY = 'playgroundV2RenewalDismiss';
export const V2_RENEWAL_FOREVER_KEY = 'playgroundV2RenewalForever';

function isDismissedToday() {
  return localStorage.getItem(V2_RENEWAL_DISMISS_KEY) === format(new Date(), 'yyyy-MM-dd');
}

function isDismissedForever() {
  return localStorage.getItem(V2_RENEWAL_FOREVER_KEY) === '1';
}

function dismissForToday() {
  localStorage.setItem(V2_RENEWAL_DISMISS_KEY, format(new Date(), 'yyyy-MM-dd'));
}

function dismissForever() {
  localStorage.setItem(V2_RENEWAL_FOREVER_KEY, '1');
}

export function canShowRenewalPopup() {
  return !isDismissedForever() && !isDismissedToday();
}

export default function PlaygroundV2RenewalPopup({ enabled }) {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setIsOpen(Boolean(enabled) && canShowRenewalPopup());
  }, [enabled]);

  const closeForToday = () => {
    dismissForToday();
    setIsOpen(false);
  };

  const closeForever = () => {
    dismissForever();
    setIsOpen(false);
  };

  if (!isOpen) {
    return null;
  }

  return (
    <div
      className="fixed inset-0 z-[111] flex items-center justify-center bg-black/75 px-5"
      role="dialog"
      aria-modal="true"
      aria-label="야옹상회 리뉴얼 안내"
    >
      <div className="flex w-full max-w-[352px] flex-col">
        <div className="relative rounded-[20px] bg-gradient-to-b from-[#EAE2FF] via-[#F3EEFF] to-white px-5 pb-5 pt-12 shadow-lg">
          <div className="pointer-events-none absolute -top-10 left-1/2 w-[88px] -translate-x-1/2">
            <YaongCat className="h-auto w-full" aria-hidden="true" />
          </div>

          <button
            type="button"
            className="absolute right-3 top-3 border-0 bg-transparent p-0 text-2xl leading-none text-[#333] outline-none focus:outline-none"
            aria-label="닫기"
            onClick={closeForToday}
          >
            ×
          </button>

          <div className="flex flex-col items-center">
            <img src={PopupSection1} alt="야옹상회 리뉴얼 안내" className="w-full max-w-[304px]" />
            <img src={PopupSection2} alt="메뉴 이동 및 미니게임 추가 안내" className="mt-3 w-full max-w-[304px]" />
            <img src={PopupSection3} alt="메뉴 이동 및 미니게임 추가 안내" className="mt-3 w-full max-w-[304px]" />
            <img src={PopupSection4} alt="메뉴 이동 및 미니게임 추가 안내" className="mt-3 w-full max-w-[304px]" />

            <button
              type="button"
              className="mt-5 w-full max-w-[304px] rounded-xl border-0 bg-black py-3.5 text-base font-bold text-white outline-none"
              onClick={closeForToday}
            >
              확인했어요
            </button>
          </div>
        </div>

        <button
          type="button"
          className="mt-4 self-start border-0 bg-transparent p-0 text-sm font-bold text-[#FFFFFF] outline-none"
          onClick={closeForever}
        >
          다시 안보기
        </button>
      </div>
    </div>
  );
}
